var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9002 7.51816C23.7707 7.03584 23.5168 6.59599 23.1639 6.24263C22.8109 5.88927 22.3714 5.6348 21.8893 5.50469C20.1145 5.02734 13 5.02734 13 5.02734C13 5.02734 5.88555 5.02734 4.11074 5.50215C3.62837 5.63184 3.18862 5.88617 2.83564 6.23959C2.48266 6.59302 2.22889 7.03309 2.0998 7.51562C1.625 9.29297 1.625 13 1.625 13C1.625 13 1.625 16.707 2.0998 18.4818C2.36133 19.4619 3.1332 20.2338 4.11074 20.4953C5.88555 20.9727 13 20.9727 13 20.9727C13 20.9727 20.1145 20.9727 21.8893 20.4953C22.8693 20.2338 23.6387 19.4619 23.9002 18.4818C24.375 16.707 24.375 13 24.375 13C24.375 13 24.375 9.29297 23.9002 7.51816ZM10.7402 16.4023V9.59766L16.6309 12.9746L10.7402 16.4023Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.fa101f7a59bcc5b2522834461785871d.svg";
export { ForwardRef as ReactComponent };